import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Typography, Box } from '@mui/material';
import heroImage from './assets/hero-image-digital-finance.jpg';
import { styled } from '@mui/material/styles';
import theme from './theme';
import KayttoehdotContent from './content/KayttoehdotContent';

const palette = {
  white: '#FFFFFF',
  darkBlue: '#122652',
  orange: 'rgb(238, 90, 0)',
};

const ImageSection = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '50vh',
  backgroundImage: `url(${heroImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(4),
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1,
  },
  '& > *': {
    position: 'relative',
    zIndex: 2,
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.paper,
  borderRadius: '10px',
  border: `1px solid ${palette.orange}`,
}));

function Kayttoehdot() {
  return (
    <>
      <Helmet>
        <title>Käyttöehdot | Rahoituskanava</title>
        <meta
          name="description"
          content="Käyttöehdot Rahoituskanava.fi palvelustamme ja sen käytöstä."
        />
        <meta
          name="keywords"
          content="käyttöehdot, Rahoituskanava, palvelun käyttö, rekisterinpitäjä, henkilötietojen käsittely"
        />
      </Helmet>

      <header>
        <ImageSection>
          <Box>
            <Typography
              variant="h2"
              component="h1"
              gutterBottom
              sx={{
                color: palette.white,
                fontSize: { xs: '2rem', md: '3rem' },
              }}
            >
              Rahoituskanava.fi käyttöehdot
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: palette.white,
                fontSize: { xs: '1rem', md: '1.25rem' },
              }}
            >
              Päivitetty 31.05.2024
            </Typography>
          </Box>
        </ImageSection>

        <Container sx={{ mb: 2 }}>
          <ContentBox>
            <Typography variant="h3" sx={{ mt: 4, color: palette.darkBlue }}>
              Käyttöehdot
            </Typography>
            <KayttoehdotContent linkSx={{ color: palette.orange }} showUpdatedDate={false} />
          </ContentBox>
        </Container>
      </header>

      <footer>
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            padding: theme.spacing(4),
            textAlign: 'center',
          }}
        >
          <Typography variant="body1">
            &copy; {new Date().getFullYear()} Rahoituskanava. Kaikki oikeudet pidätetään.
          </Typography>
        </Box>
      </footer>
    </>
  );
}

export default Kayttoehdot;
